import { HeadlineL2} from "../../styled-components/Font";
import ContactForm from "./ContactForm";
import {ContactText} from "./text";
import { Section, Separator, Title} from "../../styled-components/Base";
import useOnScreen from "../../hooks/useOnScreen";
import {useEffect, useRef, useState} from "react";
import {PopupProps} from "../../App";
import ContactInfo from "./ContactInfo";


export default function Contact({onPopupOpen, setPopupText}: PopupProps) {

    const ref = useRef(null)
    const visible = useOnScreen(ref)
    const [isVisible, setIsVisible] = useState(false)
    useEffect(() => {
        if (visible) setIsVisible(true)
    }, [visible])


    return <><Separator className={isVisible ? 'animation4' : ''}/>
        <Section ref={ref} className={'contact'}>
            <Title>
                <HeadlineL2 className={isVisible ? 'animation1' : ''}>
                    {ContactText.title}
                </HeadlineL2>
                <HeadlineL2 className={isVisible ? 'animation1' : ''}>
                    {ContactText.title1}
                </HeadlineL2>
            </Title>
            <ContactForm setPopupText={(value) => setPopupText && setPopupText(value)} visible={isVisible}/>
        </Section>
        <ContactInfo onPopupOpen={()=> onPopupOpen()}/>
    </>
}
